// extracted by mini-css-extract-plugin
export default {"buttonPrimary":"ButtonStyles_buttonPrimary__WWgpa","buttonCancel":"ButtonStyles_buttonCancel__6DO4j"};